import { isEmpty, isObjectLike, isFinite, first, toNumber } from 'lodash';

import * as DataOrigins from 'commons-vehicle/constants/dataOrigins.js';
import { BOX_SIZE_DATA, BOX_SIZE_SHORT, BOX_SIZE_LONG } from 'commons-vehicle/constants/dataConversions.js';
import {
    getDescriptionData,
    getModelTrimsBitField,
} from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import BoxSizeModel from 'commons-vehicle/ModelYear/models/BoxSizeModel.js';
/* eslint import/prefer-default-export: 0 */

function resetBoxSizeFromModelData(modelBoxSizeData) {
    if (modelBoxSizeData.length <= BOX_SIZE_DATA.CODE) {
        return new BoxSizeModel();
    }

    const code = modelBoxSizeData[BOX_SIZE_DATA.CODE];
    let rank;
    switch (code) {
        case BOX_SIZE_SHORT:
            rank = 100;
            break;
        case BOX_SIZE_LONG:
            rank = 200;
            break;
        default:
            rank = 300;
            break;
    }

    const description = getDescriptionData(modelBoxSizeData[BOX_SIZE_DATA.DESCRIPTION]);
    const boxLength = toNumber(first(description));
    if (isFinite(boxLength)) {
        rank += boxLength;
    }

    const { trimsBitField, trimsBitFields } = getModelTrimsBitField(modelBoxSizeData[BOX_SIZE_DATA.BIT_FIELD]);

    return new BoxSizeModel({
        trimsBitField,
        trimsBitFields,
        selectionCode: modelBoxSizeData[BOX_SIZE_DATA.ID_CODE],
        code,
        rank,
        description,
    });
}

export function resetBoxSizeFromOriginData(dataOrigin, originBoxSizeData) {
    if (isEmpty(originBoxSizeData) || !isObjectLike(originBoxSizeData)) {
        return new BoxSizeModel();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new BoxSizeModel();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetBoxSizeFromModelData(originBoxSizeData);

        default:
            return new BoxSizeModel();
    }
}

export default {
    resetBoxSizeFromOriginData,
};
